module.exports = __webpack_public_path__ + "img/formulariojw.56a26e71.jpg";